import ReactRootProviders from '@client/src/global/context/ReactRootProviders';
import { react2angular } from 'react2angular';
import React from 'react';
import ShipmentViewClaimFormButton from 'app/features/ShipmentView/components/FileClaimButton';
import ShipmentViewProvider from '@/features/ShipmentView/providers/ShipmentViewProvider';
import { snakeToCamelCase } from '@/utils/snakeCamelTransform';
import { IShipmentListItem } from '@typings/shipment';

function Wrapper({ shipment }: { shipment: IShipmentListItem }) {
  const shipmentItem = snakeToCamelCase(shipment);

  return (
    <ReactRootProviders>
      <ShipmentViewProvider shipmentItem={shipmentItem}>
        <ShipmentViewClaimFormButton />
      </ShipmentViewProvider>
    </ReactRootProviders>
  );
}

export const AngularShipmentViewClaimButton = react2angular(Wrapper, ['shipment']);
